/** @typedef {"regular" | "gems" | "special"} RoundKind */

const truthy = (v) =>
  v === true || v === "true" || v === 1 || v === "1";

/**
 * Classify a presale `rounds(uint256)` return value.
 * `special` wins if both `isSpecialRound` and `isGemsRound` are set.
 * @param {Record<string, unknown> | null | undefined} round
 * @returns {RoundKind}
 */
export function getRoundKind(round) {
  if (!round) return "regular";
  const isSpecial =
    truthy(round.isSpecialRound) || truthy(round[4]);
  const isGems =
    truthy(round.isGemsRound) || truthy(round[3]);
  if (isSpecial) return "special";
  if (isGems) return "gems";
  return "regular";
}

/**
 * Attach `roundKind` for UI / analytics. Safe to call more than once.
 * @param {Record<string, unknown> | null | undefined} round
 */
export function enrichRoundWithKind(round) {
  if (!round) return round;
  const roundKind = getRoundKind(round);
  return { ...round, roundKind };
}
